<div class="bookmarks">
    @if(showHeading) {
    <h3>Bookmarked Applicants <span (click)="reloadBookmarks()"><i
                [ngClass]="['reload' ,'fa', 'fa-refresh', shouldSpin()]" aria-hidden="true"></i></span></h3>
    }
    @if(bookmarks) {
    @for(b of bookmarks; track b.id) {
    <button type="button" (click)="viewBookmark(b.roleId, b.roleType)" class="bookmark">
        <span class="status-indicator" [ngClass]="calculateStatusClass(b)"></span><span class="image"><app-round-image
                [url]="getBookmarkImage(b)" [width]="32" [height]="32"></app-round-image></span>
        {{b.name}}
    </button>
    }
    }
</div>